import api from '../../api/index';
import config from '@/assets/config.json';
const state = {}
const mutations = {

}
const getters = {

}
const actions = {



    /**
     *  裂变工具-活动产品编辑
     */
    productEdit({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.newHttps.api}/merchant/activity/goods/edit`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  商家后台-应用列表
     */
    adminApplication({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/application/all`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  支付宝-图片上传接口
     */
    alipaySubmitUploadFile({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/pay/alipay/submituploadfile`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  支付宝-进件创建接口
     */
    alipaySubmitCreate({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/alipay/submitcreate`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-返现-编辑接口
     */
    editActivityShare({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/activity/share/${opt.id}`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-活动产品编辑-已选中的产品详情接口
     */
    getProductSelected({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/product/selected/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  支付-通过支付id进行支付
     */
    getPayment({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.shopHttps.api}/apishop/payment/pay/${opt.id}`).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    getPayQuery({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/pay/query/${opt.id}`).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-应用下单
     */
    applicationOrder({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/application/order`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    /**
     *  营销玩法-接龙-列表
     */
    getLinkList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/link/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-新增接口
     */
    createTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/activity/team/create`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-编辑接口
     */
    editTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/activity/team/update`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-接龙-编辑接口/merchant/activitymains
     */
    editLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.newHttps.api}/merchant/activitymains/edit`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-接龙购-新增接口
     */
    createActivityLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.newHttps.api}/merchant/activitymains/add`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },


    /**
     *  营销玩法-返现-新增接口
     */
    createActivityShare({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/activity/share`, opt).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /** /merchant/activitymains/edit 
     *  营销玩法-活动产品详情接口
     */
    getProductDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/product/detail`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-列表接口
     */
    getTeamList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.newHttps.api}/merchant/activitymains/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-活动列表接口
     */
    getProductList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/product/list`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  应用中心-应用列表
     */
    getApplication({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/application/all`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    getArticleCategory({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/article/list/by/category/code`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  公用接口-通过CODE获取一篇文章
     */
    getArticle({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/article/one/by/code`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  公用接口-通过分类CODE获取文章列表
     */
    getArticleList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/article/one/by/code`, {
                token: opt.token
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-接龙购-失效
     */
    invalidActivityLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/activity/link/invalid/${opt.id}`, {
                token: opt.token
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //活动失效
    invalidActivityApi({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.newHttps.api}/merchant/activitymains/invalid`, opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-失效
     */
    invalidActivityTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/activity/team/invalid/${opt.id}`, {
                token: opt.token
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-返现-失效
     */
    invalidActivity({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.put(`${config.brandHttps.api}/merchant/activity/share/invalid/${opt.id}`, {
                token: opt.token
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-接龙购-删除
     */
    deleteActivityLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/activity/link/delete/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-删除
     */
    deleteActivityTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/activity/team/delete/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-返现-删除
     */
    deleteActivity({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.delete(`${config.brandHttps.api}/merchant/activity/share/${opt.id}`, {
                data: {
                    token: opt.token
                }
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-接龙购-复制接口
     */
    activityCopyLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/link/copy/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-复制
     */
    activityCopyCom({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.newHttps.api}/merchant/activitymains/copy`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-复制接口
     */
    activityCopyTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/activity/team/copy/${opt.id}`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-返现-复制接口
     */
    activityCopy({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.post(`${config.brandHttps.api}/merchant/activity/share/copy/${opt.id}`,
                opt
            ).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-返现-列表接口
     */
    getActivityList({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/share`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-接龙购-详情
     */
    getActivityDetailLink({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.newHttps.api}/merchant/activitymains/detail/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    /**
     *  营销玩法-拼团-详情
     */
    getActivityDetailTeam({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/team/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    /**
     *  营销玩法-返现-详情
     */
    getActivityDetail({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            api.get(`${config.brandHttps.api}/merchant/activity/share/${opt.id}`, {
                params: opt
            }).then(data => {
                if (data) {
                    resolve(data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },





}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}